// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'

import {
  SpanWithData,
} from '../'

import {
  showAsCurrency
} from '../../utils'

export const CreditDetails = ({ creditType, eligibleFor, amount, instalment }) => (
  <tr>
    <td>
      <SpanWithData forField='CreditCreditType' searchKey={creditType} />
    </td>
    <td>
      {showAsCurrency('R', eligibleFor)}
    </td>
    <td>
      {amount ? showAsCurrency('R', amount) : null}
    </td>
    <td>
      {instalment ? showAsCurrency('R', instalment) : ''}
    </td>
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/creditapplication-issue/CreditDetails.js